import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Buy from './pages/Buy';
import DoNotBuy from './pages/DoNotBuy';
import About from './pages/About';
import Vision from './pages/Vision';
import BusinessPlan from './pages/BusinessPlan';
import Download from './pages/Download';
import Founders from './pages/Founders';
import Features from './pages/Features';
import PKM from './pages/PKM';
import FeaturesGroups from './pages/FeaturesGroups';
import TopTenFeatures from './pages/TopTenFeatures';
import PrivateSharingGroups from './pages/PrivateSharingGroups';
import AIFeatures from './pages/AIFeatures';
import ForNetworkers from './pages/ForNetworkers';
import ReleaseNotes from './pages/ReleaseNotes';
import Consolidate from './pages/Consolidate';
import Why from './pages/Why';
import AffiliateProgram from './pages/AffiliateProgram';
import AffiliateAdmin from './pages/AffiliateAdmin';
import CustomerAdmin from './pages/CustomerAdmin';
import MarketingSuggestions from './pages/MarketingSuggestions';
import AffiliateProfile from './pages/AffiliateProfile';
import AffiliateApplication from './pages/AffiliateApplication';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DataPrinciples from './pages/DataPrinciples';
import Safety from './pages/Safety';
import ContactUs from './pages/ContactUs';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SetNewPassword from './pages/SetNewPassword';
import AffiliateDashboard from './pages/AffiliateDashboard';
import AffiliatePitch from './pages/AffiliatePitch';
import AdminDashboard from './pages/AdminDashboard';
import CouponAdmin from './pages/CouponAdmin';
import UserProfileDashboard from './pages/UserProfileDashboard';
import PublicUserProfile from './pages/PublicUserProfile';
import UserProfile from './pages/UserProfile';
import UserProfileAdmin from './pages/UserProfileAdmin';
import PersonalID from './pages/PersonalID';
import MpdId from './pages/MpdId';
import LinkDesktop from './pages/LinkDesktop';
import FAQ from './pages/FAQ';
import Communities from './pages/Communities';
import TheHype from './pages/TheHype';
import ThePitch from './pages/ThePitch';
import QAndA from './pages/QAndA';
import Launch from './pages/Launch';
import ObjectNirvana from './pages/ObjectNirvana';
import GetInTouch from './pages/GetInTouch';
import ProspectAdmin from './pages/ProspectAdmin';
import Trust from './pages/Trust';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Import common styles to be available across the entire app
import './styles/mpd.css';

// Import Google Analytics
import { initGA, trackPageView } from './utils/analytics';

// Component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on first load
    initGA();
  }, []);

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageTracker />
      <Navbar />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/do-not-buy" element={<DoNotBuy />} />
        <Route path="/about" element={<About />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/id" element={<PersonalID />} />
        <Route path="/mpd-id" element={<MpdId />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/business-plan" element={<BusinessPlan />} />
        <Route path="/founders" element={<Founders />} />
        <Route path="/download" element={<Download />} />
        <Route path="/features" element={<Features />} />
        <Route path="/features-ai" element={<AIFeatures />} />
        <Route path="/pkm" element={<PKM />} />
        <Route path="/features-groups" element={<FeaturesGroups />} />
        <Route path="/top-ten-features" element={<TopTenFeatures />} />
        <Route path="/for-networkers" element={<ForNetworkers />} />
        <Route path="/private-sharing-groups" element={<PrivateSharingGroups />} />
        <Route path="/release-notes" element={<ReleaseNotes />} />
        <Route path="/consolidate" element={<Consolidate />} />
        <Route path="/why" element={<Why />} />
        <Route path="/affiliate-program" element={<AffiliateProgram />} />
        <Route path="/affiliate-pitch" element={<AffiliatePitch />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/data-principles" element={<DataPrinciples />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/communities" element={<Communities />} />
        <Route path="/the-hype" element={<TheHype />} />
        <Route path="/q-and-a" element={<QAndA />} />
        <Route path="/the-pitch" element={<ThePitch />} />
        <Route path="/launch" element={<Launch />} />
        <Route path="/object-nirvana" element={<ObjectNirvana />} />
        <Route path="/get-in-touch" element={<GetInTouch />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/affiliate-application" element={<AffiliateApplication />} />
        <Route path="/profile/:publicId" element={<PublicUserProfile />} />

        {/* Authentication routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/set-new-password" element={<SetNewPassword />} />

        {/* Protected routes - require authentication */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AffiliateDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/affiliate-dashboard"
          element={
            <ProtectedRoute>
              <AffiliateDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/link-desktop"
          element={
            <ProtectedRoute>
              <LinkDesktop />
            </ProtectedRoute>
          }
        />
        <Route
          path="/affiliate-admin"
          element={
            <ProtectedRoute>
              <AffiliateAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-admin"
          element={
            <ProtectedRoute>
              <CustomerAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prospects-admin"
          element={
            <ProtectedRoute>
              <ProspectAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/marketing-suggestions"
          element={
            <ProtectedRoute>
              <MarketingSuggestions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/affiliate-profile"
          element={
            <ProtectedRoute>
              <AffiliateProfile />
            </ProtectedRoute>
          }
        />

        {/* Admin-only routes - require admin role */}
        <Route
          path="/coupon-admin"
          element={
            <AdminRoute redirectTo="/">
              <CouponAdmin />
            </AdminRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute redirectTo="/">
              <AdminDashboard />
            </AdminRoute>
          }
        />
        {/* TEMPORARILY DISABLED ADMIN ROUTE - TO RE-ENABLE: wrap with <AdminRoute> */}
        <Route path="/user-profile-dashboard" element={<UserProfileDashboard />} />
        <Route path="/user-profile-admin" element={<UserProfileAdmin />} />
        {/* Original admin-protected route (commented for re-enablement):
        <Route
          path="/user-profile-dashboard"
          element={
            <AdminRoute>
              <UserProfileDashboard />
            </AdminRoute>
          }
        />
        */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
